import { render, staticRenderFns } from "./ModalAlertError.vue?vue&type=template&id=d1b0b2d2&scoped=true"
import script from "./ModalAlertError.vue?vue&type=script&lang=js"
export * from "./ModalAlertError.vue?vue&type=script&lang=js"
import style0 from "./ModalAlertError.vue?vue&type=style&index=0&id=d1b0b2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b0b2d2",
  null
  
)

export default component.exports